(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-drawer"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
  const popup = document.getElementById('confirmPopupDrawer');
  const popupYes = document.getElementById('popupYesDrawer');
  const popupNo = document.getElementById('popupNoDrawer');
  const popupLinks = document.querySelectorAll('a[data-popup="headerDrawer"]');

  popupLinks.forEach((link) => {
    link.addEventListener('click', function (e) {
      e.preventDefault();

      const categoryLink = link.getAttribute('data-link');
      const target = link.getAttribute('data-target') || '_blank';

      // Set href and target for "Yes"
      popupYes.setAttribute('href', categoryLink);
      popupYes.setAttribute('target', target);

      // Show popup
      popup.style.display = 'flex';
    });
  });

   popupYes.addEventListener('click', function () {
      popup.style.display = 'none';
   });

  // Close the popup on "No"
  popupNo.addEventListener('click', function () {
    popup.style.display = 'none';
  });
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["header-dropdown-menu"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
  const popup = document.getElementById('confirmPopupHeader');
  const popupYes = document.getElementById('popupYesHeader');
  const popupNo = document.getElementById('popupNoHeader');
  const popupLinks = document.querySelectorAll('a[data-popup="header"]');

  popupLinks.forEach((link) => {
    link.addEventListener('click', function (e) {
      e.preventDefault();

      const categoryLink = link.getAttribute('data-link');
      const target = link.getAttribute('data-target') || '_blank';

      // Set href and target for "Yes"
      popupYes.setAttribute('href', categoryLink);
      popupYes.setAttribute('target', target);

      // Show popup
      popup.style.display = 'flex';
    });
  });

  popupYes.addEventListener('click', function () {
      popup.style.display = 'none';
   });

  // Close the popup on "No"
  popupNo.addEventListener('click', function () {
    popup.style.display = 'none';
  });
});
  } catch(e) { console.error(e); }
})();

})();
